export default "__VITE_ASSET__Dadt4hDn__"